import bookingAPI from "@/api/booking";
import types from "../types";

// initial state
const state = {
  // cabinConfigurationIDs: [],
  // cabinConfigurationEntities: [],
  ids: [],
  entities: {},
};

const getCabinConfigurations = (state) =>
  state.ids.map((id) => state.entities[id]);

// getters
const getters = {
  [types.getters.cabinConfigurations]: getCabinConfigurations,
};

// actions
const actions = {
  [types.actions.updateCabinConfigurationField](
    { commit },
    { cabinConfigurationID, fieldName, value },
  ) {
    commit(types.mutations.updateCabinConfigurationField, {
      cabinConfigurationID,
      fieldName,
      value,
    });
  },
  [types.actions.updateCabinConfigurationRemote](
    { commit },
    { cabinConfigurations },
  ) {
    const changedCabinConfigurations = cabinConfigurations.filter(
      (cabinConfiguration) => cabinConfiguration.isDirty,
    );
    if (!changedCabinConfigurations.length) {
      return Promise.resolve();
    }

    commit(types.mutations.setIsLoading, { isLoading: true });

    return bookingAPI
      .updateCabinConfiguration(changedCabinConfigurations)
      .then((res) => {
        commit(types.mutations.resetCabinConfigurationsDirtyFlag);
        return res;
      })
      .finally(() => {
        commit(types.mutations.setIsLoading, { isLoading: false });
      });
  },
};

// mutations
const mutations = {
  [types.mutations.setCabinConfigurations](state, cabinConfigurations) {
    state.ids = cabinConfigurations.map(
      (cabinConfiguration) => cabinConfiguration.cabinConfigurationID,
    );
    state.entities = cabinConfigurations.reduce((accumulate, current) => {
      accumulate[current.cabinConfigurationID] = current;
      return accumulate;
    }, {});
  },
  [types.mutations.setCruiseTicketURL](
    state,
    cruiseTicketURLByCabinConfigurations,
  ) {
    getCabinConfigurations(state).forEach((entity) => {
      const fileURL =
        cruiseTicketURLByCabinConfigurations[entity.cabinConfigurationID];
      if (fileURL) {
        entity.cruiseTicketURL = fileURL;
      }
    });
  },
  [types.mutations.updateCabinConfigurationField](
    state,
    { cabinConfigurationID, fieldName, value },
  ) {
    state.entities[cabinConfigurationID][fieldName] = value;
    state.entities[cabinConfigurationID].isDirty = true;
  },
  [types.mutations.resetCabinConfigurationsDirtyFlag](state) {
    getCabinConfigurations(state).forEach((entity) => (entity.isDirty = false));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/cabinConfiguration.js